import { apiClient, omrehBaseClient } from "./client";

const BrokerGroupDropDown = (brokerId) => {
  return omrehBaseClient
    .get("/BrokerGroup/BrokerGroupDropDown", {
      params: {
        'BrokerId': brokerId
      }
    });
}

const brokerGroupApi = {
  BrokerGroupDropDown
}

export default brokerGroupApi